<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Customização de Ficha de EPI
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div>
        <div class="q-ml-sm texto-titulo-input">Unidade</div>
        <lista-unidades-select v-model="unidade.nome" />
      </div>

      <div class="col-md-4 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Título da Ficha</div>
        <q-input v-model="dados.tituloFicha" dense outlined class="input" />
      </div>
      <div class="q-ml-lg">
        <p></p>
        <q-btn
          icon="content_copy"
          color="brand-1"
          :outline="!duplicarFicha"
          label="Duplicar a Ficha de EPI"
          dense
          class="q-mt-sm"
          no-caps
          @click="duplicarFicha = !duplicarFicha"
        />
      </div>

      <div v-if="alterarLogo" class="col-md-2 col-xs-6 q-ml-sm">
        <div class="q-ml-sm texto-titulo-input">Novo logo</div>
        <q-file dense outlined v-model="imagem" label="Alterar imagem" />
      </div>
      <div class="col-md-2 col-xs-6 q-ml-sm q-mt-md">
        <p></p>
        <q-btn
          :outline="!alterarLogo"
          :icon="alterarLogo == true ? 'add' : 'image'"
          :color="alterarLogo == true ? 'positive' : 'secondary'"
          label="Alterar logo impressão"
          dense
          no-caps
          @click="alterarLogo == true ? trocarLogo() : (alterarLogo = true)"
        />
      </div>

      <div v-if="duplicarFicha" class="row col-12 q-gutter-sm q-my-lg q-ml-lg">
        <div class="col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm texto-titulo-input">Selecione a Unidade</div>
          <q-select
            option-label="nome"
            option-value="id"
            :options="listaUnidades"
            dense
            outlined
            class="select"
            v-model="unidadeDuplicar"
          />
        </div>
        <div>
          <p></p>
          <q-btn
            icon="check_circle_outline"
            color="positive"
            outline
            label="Duplicar Ficha"
            dense
            class="q-mt-sm"
            no-caps
          />
        </div>
      </div>
      <div class="col-md-7 col-sm-5 col-xs-5 q-mt-lg">
        <div class="q-ml-sm texto-titulo-input">
          Descreva as Diretrizes da Ficha
        </div>
        <q-input
          v-model="dados.diretrizesFicha"
          dense
          outlined
          type="textarea"
          class="select"
        />
      </div>
    </div>
    <div class="row col-12 colunas-titulo">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Colunas da Ficha de EPI
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">
          Selecione as Colunas do Usuário
        </div>
        <q-select
          v-model="dados.colunaUsuario"
          :options="listaColunasUsuario"
          dense
          outlined
          class="select"
          hide-selected
          :disable="disable"
        />
        <div
          class="q-mt-sm col-12"
          v-for="(coluna, index) in listaColunasUsuarioAtivas"
          :key="index"
        >
          <div
            v-if="coluna.ativo"
            class="row col-12 items-center justify-between card-coluna"
          >
            <span>{{ coluna.info_usuario }}</span
            ><q-icon
              name="close"
              size="18px"
              style="cursor: pointer"
              @click="desativarColunaUsuario(coluna.info_usuario)"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5 q-ml-xl">
        <div class="q-ml-sm texto-titulo-input">
          Selecione as Colunas dos Itens
        </div>
        <q-select
          v-model="dados.colunaEntrega"
          :options="listaColunasEntrega"
          dense
          hide-selected
          outlined
          class="select"
          :disable="disable"
        />
        <div
          class="q-mt-sm col-12"
          v-for="(coluna, index) in listaColunasEntregasAtivas"
          :key="index"
        >
          <div
            v-if="coluna.ativo"
            class="row col-12 items-center justify-between card-coluna"
          >
            <span>{{ coluna.info_entrega }}</span
            ><q-icon
              name="close"
              size="18px"
              style="cursor: pointer"
              @click="desativarColunaEntrega(coluna.info_entrega)"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3 q-ml-xl">
        <div class="texto-titulo-input q-mb-xs">
          Adicionar Assinatura da Ficha
        </div>
        <q-radio
          v-model="dados.rodape"
          class="q-ml-md"
          label="Sim"
          :disable="disableRadio"
          :val="true"
        />
        <q-radio
          v-model="dados.rodape"
          label="Não"
          :val="false"
          :disable="disableRadio"
        />
      </div>
    </div>
    <div class="row col-12 justify-start q-ml-md q-mt-lg">
      <div>
        <q-btn
          dense
          no-caps
          icon="check_circle_outline"
          color="positive"
          label="Salvar Customização"
          @click="alterarCabecalho()"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const imagem = ref(null);
    const alterarLogo = ref(false);
    let duplicarFicha = ref(false);
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const listaUnidades = ref([]);
    const unidadeDuplicar = ref({ nome: "", id: "" });
    const listaColunasEntrega = ref([]);
    const listaColunasUsuario = ref([]);
    const dados = ref({
      colunaEntrega: "",
      colunaUsuario: "",
      tituloFicha: "",
      diretrizesFicha: "",
      rodape: "",
      template: "",
    });
    const listaColunasEntregasAtivas = ref([]);
    const listaColunasUsuarioAtivas = ref([]);
    let disable = ref(false);
    let disableRadio = ref(false);

    const listarColunasEntrega = async () => {
      try {
        disable.value = true;
        await unidade.value.id;
        const response = await store.dispatch("office/listarColunasEntrega", {
          vendor_id: unidade.value.id,
        });
        let array = [
          "Planta",
          "Função/GHE",
          "Centro de Custo",
          "Área",
          "Resp. CC",
          "Num Voucher",
          "Entregue em",
          "Cód. Produto",
          "Descrição",
          "CA",
          "Quantidade",
          "Requisição",
          "Retirada",
        ];
        listaColunasEntregasAtivas.value = response.data.response;
        if (response.data.response != "") {
          response.data.response.forEach((coluna) => {
            if (coluna.ativo) {
              array = array.filter((col) => col != coluna.info_entrega);
            }
          });
        }
        listaColunasEntrega.value = array;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const getAssinatura = async () => {
      disableRadio.value = true;
      try {
        const response = await store.dispatch(
          "seguranca/receberConfiguracaoAssinaturaRodape"
        );
        if (response.data.data.length > 0) {
          let array = [];
          array = response.data.data.filter(
            (unidade) => unidade.id === store.state.org.unidadeData.id
          );
          dados.value.rodape = array[0].mostrar ? true : false;
        }
        disableRadio.value = false;
      } catch (error) {
        console.log(error);
        disableRadio.value = false;
      }
    };

    const alterarConfiguracaoAssinaturaRodape = async () => {
      try {
        await store.dispatch("seguranca/alterarConfiguracaoAssinaturaRodape", {
          vendor_id: store.state.org.unidadeData.id,
          mostrar: dados.value.rodape,
        });
        getAssinatura();
      } catch (error) {
        console.log(error);
        disableRadio.value = false;
      }
    };

    const listarColunasUsuario = async () => {
      try {
        disable.value = true;
        await unidade.value.id;
        const response = await store.dispatch("office/listarColunasUsuario", {
          vendor_id: unidade.value.id,
        });
        let array = [
          "Nome",
          "ID Usuário",
          "Data admissão",
          "Data demissão",
          "Cargo",
          "Função/GHE",
        ];
        listaColunasUsuarioAtivas.value = response.data.response;
        if (response.data.response != "") {
          response.data.response.forEach((coluna) => {
            if (coluna.ativo) {
              array = array.filter((col) => col != coluna.info_usuario);
            }
          });
        }
        listaColunasUsuario.value = array;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const ativarColunaEntrega = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaEntrega", {
          vendor_id: unidade.value.id,
          info_entrega: coluna,
          ativo: true,
        });
        dados.value.colunaEntrega = "";
        listarColunasEntrega();
        quasar.notify({
          message: "Coluna ativada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao ativar coluna",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const ativarColunaUsuario = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaUsuario", {
          vendor_id: unidade.value.id,
          info_usuario: coluna,
          ativo: true,
        });
        dados.value.colunaUsuario = "";
        listarColunasUsuario();
        quasar.notify({
          message: "Coluna ativada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao ativar coluna",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const desativarColunaEntrega = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaEntrega", {
          vendor_id: unidade.value.id,
          info_entrega: coluna,
          ativo: false,
        });
        listarColunasEntrega();
        quasar.notify({
          message: "Coluna desativada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao desativar coluna",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const desativarColunaUsuario = async (coluna) => {
      try {
        await store.dispatch("office/ativarDesativarColunaUsuario", {
          vendor_id: unidade.value.id,
          info_usuario: coluna,
          ativo: false,
        });
        listarColunasUsuario();
        quasar.notify({
          message: "Coluna desativada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao desativar coluna",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listarUnidades = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        listaUnidades.value = response.listaUnidades;
      } catch (error) {
        console.log(error);
      }
    };

    const trocarLogo = async () => {
      if (imagem.value == null) {
        quasar.notify({
          message: "Selecione uma imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(imagem.value);
        fileReader.addEventListener("load", async () => {
          try {
            await store.dispatch("seguranca/uploadImagemLogo", {
              imagem: fileReader.result,
              vendor_id: unidade.value.id,
            });

            quasar.notify({
              message: "Imagem enviada com sucesso",
              color: "positive",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            imagem.value = null;
          } catch (error) {
            quasar.notify({
              message: "Erro a o enviar imagem",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        });
        alterarLogo.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o enviar imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        console.log(error);
      }
    };

    const receberCabecalho = async () => {
      try {
        await unidade.value.id;
        const response = await store.dispatch("office/receberCabecalho", {
          vendor_id: unidade.value.id,
        });
        if (response.data.response != null) {
          const array = response.data.response;
          dados.value.tituloFicha = array.titulo;
          dados.value.diretrizesFicha = array.cabecalho;
          return;
        }
        dados.value.tituloFicha = "";
        dados.value.diretrizesFicha = "";
        dados.value.rodape = "";
      } catch (error) {
        console.log(error);
      }
    };

    const alterarCabecalho = async () => {
      if (dados.value.tituloFicha == "") {
        quasar.notify({
          message: "Preencha o campo de titulo da ficha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dados.value.rodape != true && dados.value.rodape != false) {
        quasar.notify({
          message: "Selecione uma opção de assinatura",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("office/alterarCabecalho", {
          vendor_id: unidade.value.id,
          cabecalho: dados.value.diretrizesFicha,
          titulo: dados.value.tituloFicha,
          rodape: dados.value.rodape,
          template: dados.value.template,
        });
        await alterarConfiguracaoAssinaturaRodape();
        receberCabecalho();
        quasar.notify({
          message: "Customização salva com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao salvar customização",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarColunasEntrega();
        listarColunasUsuario();
        receberCabecalho();
      }
    );

    watch(
      () => dados.value.colunaEntrega,
      () => {
        if (dados.value.colunaEntrega != "") {
          ativarColunaEntrega(dados.value.colunaEntrega);
        }
      }
    );

    watch(
      () => dados.value.colunaUsuario,
      () => {
        if (dados.value.colunaUsuario != "") {
          ativarColunaUsuario(dados.value.colunaUsuario);
        }
      }
    );

    onMounted(listarColunasEntrega);
    onMounted(listarUnidades);
    onMounted(listarColunasUsuario);
    onMounted(receberCabecalho);
    onMounted(getAssinatura);

    return {
      duplicarFicha,
      listarColunasEntrega,
      unidade,
      listarUnidades,
      listaUnidades,
      unidadeDuplicar,
      listaColunasEntrega,
      dados,
      ativarColunaEntrega,
      listaColunasEntregasAtivas,
      desativarColunaEntrega,
      disable,
      alterarConfiguracaoAssinaturaRodape,
      listarColunasUsuario,
      listaColunasUsuarioAtivas,
      listaColunasUsuario,
      desativarColunaUsuario,
      receberCabecalho,
      alterarCabecalho,
      imagem,
      alterarLogo,
      trocarLogo,
      disableRadio,
    };
  },
};
</script>

<style scoped>
.colunas-titulo {
  margin: 60px 0px 0px 0px;
}
.card-coluna {
  background-color: #dfebf2;
  padding: 4px 4px 6px 20px;
  border-radius: 5px;
}
</style>
